import { Component } from '@angular/core';
import {MENU_PAGE} from "../shared/defines/desktop.const";

@Component({
  selector: 'app-legal-notice',
  templateUrl: './legal-notice.component.html',
  styleUrls: ['./legal-notice.component.scss']
})
export class LegalNoticeComponent {

  protected readonly MENU_PAGE = MENU_PAGE;
}
